import useEarningTypes from './data/useEarningTypes'
import useCampaignTypes from './data/useCampaignTypes'
import CampaignProducts from './data/CampaignProducts'
import CampaignProductsGiveAway from './data/CampaignProductsGiveAway'
import {useReferral} from '../hook'
import SelectProducts from './components/SelectProducts'
import SelectGiftProducts from './components/SelectGiftProduct'
import {useIntl} from 'react-intl'

function ReferralCampaignEdit({
  Field,
  Form,
  setFieldValue,
  values,
  touched,
  errors,
  section,
  setSection,
  disabled,
}: {
  Field: any
  Form: any
  setFieldValue: any
  values: any
  touched: any
  errors: any
  section: any
  setSection: any
  disabled: boolean
}) {
  const intl = useIntl()
  const {sectionRender} = useEarningTypes()
  const {sectionRender: sectionRenderCampaign} = useCampaignTypes()

  const {
    referralCampaignProductListAll,
    referralCampaignProductListAllSet,
    selectedGiveAwayProductSet,
  } = useReferral()

  return (
    <>
      {section === 1 && (
        <div className='p-5'>
          {/* {disabled && (
            <div className='alert-light-danger' role='alert'>
              {intl.formatMessage({ id: 'CAMPAIGN.LIVE' })}
            </div>
          )} */}
          <Form className='form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework w-100'>
            <div className='row  mt-10 w-100'>
              <div className='col-md-12'>
                <div className='card'>
                  <div className='card-header'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                        {intl.formatMessage({id: 'CAMPAIGN.TITLE'})}
                      </div>
                    </div>
                  </div>
                  <div className={`card-body card-disabled`}>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='input-group input-group-solid w-100'>
                          <Field
                            type='text'
                            name='title'
                            id='title'
                            placeholder='e.g. %5 off on all products'
                            className='form-control form-control-sm form-control-solid'
                            maxLength={51}
                          />
                        </div>

                        {errors.name && touched.name && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{errors.name}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card mt-10'>
                  <div className='card-header'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                        {intl.formatMessage({id: 'CAMPAIGN.EARNING_TYPE'})}&nbsp;
                        <span className='fs-2 text-danger'> *</span>
                      </div>
                    </div>
                  </div>
                  <div className={`card-body mt-5 pt-2 pb-2 ${disabled ? 'card-disabled' : ''}`}>
                    <div>
                      {sectionRenderCampaign(Field, values, setFieldValue)}
                      {sectionRender(Field, values, setFieldValue, disabled)}
                    </div>
                  </div>

                  <div className='card-footer'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <span
                        className='fs-6'
                        dangerouslySetInnerHTML={{
                          __html: intl.formatMessage({id: 'ONE_DOLLAR_EQUAL_ONE_POINT'}),
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className='card mt-10'>
                  <div className='card-header'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                        {intl.formatMessage({ id: 'CAMPAIGN.PRODUCTS.SELECTED' })}
                      </div>
                    </div>
                  </div>
                  <CampaignProducts
                    Field={Field}
                    setSection={setSection}
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                </div>
                {values.promoGroup === '6' || values.promoGroup === '15' ? (
                  <div className='card mt-10'>
                    <div className='card-header'>
                      <div className='card-title d-flex flex-column'>
                        <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                          {intl.formatMessage({ id: 'CAMPAIGN.GIVE_AWAY_PRODUCTS' })}
                        </div>
                      </div>
                    </div>
                    <CampaignProductsGiveAway
                      Field={Field}
                      values={values}
                      setFieldValue={setFieldValue}
                      setSection={setSection}
                    />
                  </div>
                ) : null} */}
              </div>
            </div>
          </Form>
        </div>
      )}

      {section === 2 && (
        <SelectProducts
          allProducts={referralCampaignProductListAll.data}
          paging={referralCampaignProductListAll.paging}
          pagingSet={(paging: any) => {
            referralCampaignProductListAllSet({
              ...referralCampaignProductListAll,
              paging,
            })
          }}
          handleBack={() => setSection(1)}
          setSection={setSection}
        />
      )}

      {section === 3 && (
        <SelectGiftProducts
          allProducts={referralCampaignProductListAll.data}
          paging={referralCampaignProductListAll.paging}
          pagingSet={(paging: any) => {
            referralCampaignProductListAllSet({
              ...referralCampaignProductListAll,
              paging,
            })
          }}
          handleBack={() => setSection(1)}
          setSection={setSection}
          selectedProducts={values.priceCluster?.[0]?.productList || []}
          setSelectedProducts={(productList) => {
            const priceCluster = values.priceCluster.map((item: any) => ({
              ...item,
              productList,
            }))

            setFieldValue('priceCluster', priceCluster)
          }}
        />
      )}
    </>
  )
}

export default ReferralCampaignEdit
